import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: '/',
		component: Dashboard
	},
	{
		path: '/tramites',
		name: 'tramites',
		component: () => import('../views/Tramites.vue')
	},
	{
		path: '/tramite/:id',
		name: 'tramite',
		component: () => import('../views/Tramite.vue')
	},
	{
		path: '/servicios',
		name: 'servicios',
		component: () => import('../views/Servicios.vue')
	},
	{
		path: '/onomastico',
		name: 'onomastico',
		component: () => import('../views/Onomastico.vue')
	},
	{
		path: '/bolsa_trabajo',
		name: 'bolsa_trabajo',
		component: () => import('../views/BolsaTrabajo.vue')
	},
	{
		path: '/nosotros',
		name: 'nosotros',
		component: () => import('../views/Nosotros.vue')
	},
	{
		path: '/documentos_normativos',
		name: 'documentos_normativos',
		component: () => import('../views/DocumentosNormativos.vue')
	},
	{
		path: '/noticias/:id?',
		name: 'noticias',
		component: () => import('../views/Noticias.vue')
	},
	{
		path: '/cursos',
		name: 'cursos',
		component: () => import('../views/Cursos.vue')
	},
	{
		path: '/eventos',
		name: 'eventos',
		component: () => import('../views/Eventos.vue')
	},
	{
		path: '/mesa_partes_virtual',
		name: 'mesa_partes_virtual',
		component: () => import('../views/MesaPartesVirtual.vue')
	},
	{
		path: '/busqueda_colegiado',
		name: 'busqueda_colegiado',
		component: () => import('../views/BusquedaColegiado.vue')
	},
	{
		path: '/estadisticas_colegiados/:sexo?',
		name: 'estadisticas_colegiados',
		component: () => import('../views/EstadisticaColegiados.vue')
	},
	{
		path: '/contactenos',
		name: 'contactenos',
		component: () => import('../views/Contactenos.vue')
	},
	{
		path: '/comunicado/:id',
		name: 'comunicado',
		component: () => import('../views/Comunicado.vue')
	},
	{
		path: '/pronunciamiento/:id',
		name: 'pronunciamiento',
		component: () => import('../views/Pronunciamiento.vue')
	},
	{
		path: '/galeria',
		name: 'galeria',
		component: () => import('../views/Galeria.vue')
	},
	{
		path: '*',
		name: 'NotFound',
		property: {},
		children: [],
		component: () => import('../views/Error404.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
